/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="services.module.ts" />

module Meevo.Plugins.Services {
    class ServicesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

      static $inject = [
        "meevo.AppSettings",
        "meevo.components.common.DataService",
        "meevo.components.modal.ModalService",
        "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService",
        "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
        "$rootScope",
        "$scope",
        "$state",
        "meevo.ContextParams",
        'meevo.components.short-cuts.ShortCutsService',
        "meevo.components.busy.BusyService",
        "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected loggingService: Meevo.Components.Logging.ILoggingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected $rootScope: angular.IRootScopeService,
          protected $scope: angular.IScope,
          protected $state: any,
          protected contextParams: Meevo.ContextParamsService,
          protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
          protected busyService: Meevo.Components.Busy.IBusyService,
          protected $translate: angular.translate.ITranslateService) {

          super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService, {
            use: true,
            udfNoun: Meevo.Model.NounEnum.ServiceUDF,
            appAreaEnum: Meevo.Model.AppAreaEnum.Service
          });

        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
          let vm = this;
          vm.busyService.start();
          vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_SERVICE).then(() => {
            vm.busyService.stop();
            vm.context = new ServicesContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.customDataContextConfig,vm.busyService, vm.$translate, vm.contextParams);
            super.createContext();
            //vm.context.activate(vm.selectedItemId);
            vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
            vm.context.deactivate = () => {
              vm.visualState = Model.MaintenanceFormVisualState.Search;
            }

            // Use translate service to populate field list
            this.context.locationFieldList =
                [
                { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                { field: 'PriceLevels', label: this.$translate.instant("LABEL_PRICE_LEVEL"), checked: false },
                { field: 'ServiceSteps', label: this.$translate.instant("HEADER_SERVICE_STEPS"), checked: false },
                {field:  'IsDepositEnabled', label: this.$translate.instant("LABEL_SERVICE_REQUIRES_DEPOSIT"), checked: false },
                {field:  'DepositAmount', label: this.$translate.instant("LABEL_DEPOSIT_PERCENTAGE_AMOUNT_REQUIRED"), checked: false },
                { field: 'CostPerService', label: this.$translate.instant("LABEL_COST_PER_SERVICE"), checked: false }
              ];
          });

        }

        public exportServiceList(): void {            
            this.busyService.start();
            this.dataService.customMethodData('/api/service/export', 'GET', null).then(resp => {
                this.busyService.stop();
                setTimeout(() => {
                    Meevo.Components.Common.Utilities.downloadFile(null, resp.data, 'service-export.csv');
                }, 1);
            });
        }
    }

    angular.module("meevo.plugins.services")
        .controller("meevo.plugins.services.ServicesController", ServicesController);
}
